import React from "react";
import { Box, Typography, Button } from "@mui/material";
import BottomSheetDialog from "./mobile-bottom-sheet";
import DateInput from "../../ui/date-input";

export interface DateConfirmPopupProps {
    open: boolean;
    message?: string;
    red?: boolean;
    description?: string;
    footer?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    dateLabel?: string;
    value: string;
    minDate?: string;
    onChange: (value: string) => void;
    onConfirm: () => void;
    onCancel: () => void;
    confirmDisabled?: boolean;
}

// Bottom-sheet phone equivalent of date-confirm.tsx.
const DateConfirmPopupMobile: React.FC<DateConfirmPopupProps> = ({
    open,
    message = "Are you sure?",
    red = false,
    footer,
    description = "This action cannot be undone.",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    dateLabel = "End Date",
    value,
    minDate,
    onChange,
    onConfirm,
    onCancel,
    confirmDisabled = false,
}) => (
    <BottomSheetDialog open={open} onClose={onCancel} fitContent heightVh={75}>
        <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="h6" fontWeight={700} mb={1.5} color={red ? "#F44336" : "inherit"}>
                {message}
            </Typography>
            <Typography
                color="text.secondary"
                fontSize={15}
                mb={3}
                component="div"
                dangerouslySetInnerHTML={description ? { __html: description } : undefined}
            />
            <Box mb={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                <DateInput label={dateLabel} value={value} onChange={onChange} minDate={minDate} />
            </Box>
            {footer && (
                <Typography fontWeight={600} mb={1.5} color="text.secondary">
                    {footer}
                </Typography>
            )}
            <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={confirmDisabled}
                sx={{ borderRadius: 2, fontWeight: 600, fontSize: 16, py: 1.2, mb: 1.5, boxShadow: 'none', textTransform: 'none', color: '#fff' }}
                onClick={onConfirm}
            >
                {confirmLabel}
            </Button>
            <Button
                variant="outlined"
                color="primary"
                fullWidth
                sx={{ borderRadius: 2, fontWeight: 600, fontSize: 16, py: 1.2, textTransform: 'none' }}
                onClick={onCancel}
            >
                {cancelLabel}
            </Button>
        </Box>
    </BottomSheetDialog>
);

export default DateConfirmPopupMobile;
